import _orderBy from 'lodash/orderBy.js'

class RoundTally {
  constructor({ teams }) {
    this.tallied = {}
    this.rounds = []
    this.round = 0
    for(const team of (teams || [])) {
      this.tallied[team._id] = new TeamTally(team._id)
    }
  }

  addMatch(match) {
    if(this.round < match.round) {
      this.crunchRound(match.round)
    }

    const [home, away] = match.teams.map(t => t._id)
    if(!this.tallied[home]) {
      this.tallied[home] = new TeamTally(home)
    }
    if(!this.tallied[away]) {
      this.tallied[away] = new TeamTally(away)
    }
    const score = [...(match.score || [0, 0])]
    this.tallied[home].addResult(score)
    this.tallied[away].addResult(score.reverse())
  }

  crunchRound(round) {
    const standings = _orderBy(Object.values(this.tallied), [
      'points',
      'goals',
      'diff',
    ], [
      'desc',
      'desc',
      'desc',
    ])

    let prev
    let rank = 0
    const result = standings.map((tally, i) => {
      if(!(tally.goals === prev?.goals
        && tally.against === prev?.against
        && tally.diff === prev?.diff
      )) {
        rank = i + 1
      }
      prev = tally

      return {
        ...tally,
        round: this.round,
        rank,
      }
    })
    if(result.length) {
      this.rounds.push(result)
    }

    this.round = round
  }
}

class TeamTally {
  constructor(team) {
    this.team = team
    this.points = 0
    this.goals = 0
    this.against = 0
    this.diff = 0
  }

  addResult([goals, against]) {
    this.goals += goals
    this.against += against
    this.diff = this.goals - this.against
    if(goals > against) {
      this.points += 3
    } else if(goals === against) {
      this.points += 1
    }
  }
}

export function computeLeagueResults({ matches, teams }) {
  matches = _orderBy(matches, [
    'round',
  ])

  const now = new Date()
  const rounds = new RoundTally({ teams })
  for(const match of matches) {
    if(match.status !== 'confirmed') {
      continue
    }
    if(new Date(match.startTime) > now) {
      break
    }

    rounds.addMatch(match)
  }
  rounds.crunchRound()

  return rounds.rounds
}
